// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.admin-box .el-table__expanded-cell {\n  padding: 20px 50px !important;\n}\n.demo-table-expand {\n  font-size: 0;\n}\n.demo-table-expand label {\n  width: 90px;\n  color: #99a9bf;\n}\n.demo-table-expand .el-form-item {\n  margin-right: 0;\n  margin-bottom: 0;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
